import { localStore } from 'helpers';
import { Tip } from 'modules/common/components';
import {
	isAccessForAll,
	permissionKeys,
	permissionModulesKeys,
	setBadge,
} from 'modules/common/utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { globalStateSelector } from 'store/selector';
import styled from 'styled-components';
import APIManager from "modules/common/apiManager";
import { companyMenuIcon, globalUrlList } from '../../../../../helpers/dotenv';
import { agentAccess, otherAccess, otherUser, userAccess } from '../../../../../helpers/system-config';
import CommonManager from '../../../../../helpers/common';
import { Alert } from '../../../../common/utils';
import consts from "consts";

const commonManager = new CommonManager();
let companyIcon = commonManager.isValidUrl(companyMenuIcon) ? companyMenuIcon : `/images/${companyMenuIcon}`;

const mAPI = new APIManager();

const LeftNavigation = styled.aside`
	width: 100px;
	padding-right: 30px;
	background: linear-gradient(180deg, #4a02fa 0%, #312ea9 48.96%, #155e7a 100%);
	z-index: 10;
	flex-shrink: 0;
	overflow: hidden;
	position: fixed;
	left: 0;
	top: 0;
	bottom: 0;

	::before {
		background: url(/images/new/menu-bg.png);
		content: '';
		position: absolute;
		bottom: 0px;
		width: 100%;
		height: 100%;
		background-position: bottom;
		background-repeat: no-repeat;
		z-index: -999;
	}

	.menu-icon {
		display: flex;
		margin-top: 20px;
		justify-content: center;
		align-items: center;

		img {
			@media (max-width: 760px) {
				margin-top: 25px;
				width: 80px;
				margin-left: 5px;
			}
			transition: all 0.3s ease;
			&:hover {
				transform: scale(1.1);
			}
		}
	}
	@media (max-width: 767px) {
		width: 90px;
		padding-right: 15px;
		display: none;
	}
`;
const Nav = styled.nav`
	display: block;
	width: 100%;
	height: calc(100% - 80px);
	overflow: auto;
	margin: 20px 0;

	> a {
		display: flex;
		text-align: center;
		position: relative;
		transition: all 0.3s ease;
		width: 50px;
		height: 50px;
		margin: 20px auto;
		border-radius: 10px;
		align-items: center;
		justify-content: center;
		color: #fff;
		text-decoration: none;

		&:first-child {
			margin-top: 0;
		}

		span {
			font-size: 32px;
			font-weight: 400;
		}

		svg {
			vertical-align: middle;
		}

		&.active,
		&:hover {
			color: #28a6de;
			&:before {
				color: #28a6de;
				border-right: 2px solid currentcolor;
				border-bottom: 2px solid currentcolor;
				content: '';
				position: absolute;
				width: 10px;
				height: 10px;
				left: -16px;
				transform: rotate(45deg);
				background: #28a6de;
				top: 20px;
			}
			path {
				stroke: #fff;
			}
		}
		&:hover {
			i {
				opacity: 1;
			}
		}
	}
	&::-webkit-scrollbar {
		display: none;
	}
`;

const NavIcon = styled.i`
	display: inline-flex;
`;

const Mobilenavicon = styled.div`
	display: none;
	@media (max-width: 767px) {
		height: 100%;
		display: block;
		width: 100px;
		background: linear-gradient(
			180deg,
			#4a02fa 0%,
			#312ea9 48.96%,
			#155e7a 100%
		);
		z-index: 10;
		-webkit-flex-shrink: 0;
		-ms-flex-negative: 0;
		flex-shrink: 0;
		overflow: hidden;
		position: fixed;
		left: 0;
		top: 0;
		bottom: 0;
		padding-left: 15px;
		transition: all 3s ease;
		z-index: 98;
	}
`;

const NavMob = styled.nav`
	display: block;
	margin-top: 85px;
	height: calc(100% - 80px);
	overflow: auto;
	width: 65px;
	@media (max-width: 767px) {
		> a {
			width: 55px !important;
			height: 55px !important;
			margin: 15px auto !important;
			color: #fff;
		}
		span {
			right: 10px !important;
			bottom: 9px !important;
			padding: 0px !important;
			font-size: 35px;
		}
	}
	> a {
		display: block;
		text-align: center;
		position: relative;
		transition: all 0.3s ease;
		width: 45px;
		height: 45px;
		margin: 25px auto;
		border-radius: 9px;
		span {
			position: absolute;
			right: 12px;
			bottom: 12px;
			padding: 4px;
			min-width: 19px;
			min-height: 19px;
		}
		svg {
			vertical-align: middle;
		}
		&.active,
		&:hover {
			background: #0161ed;
			path {
				stroke: #fff;
			}
		}
		&:hover {
			i {
				opacity: 1;
			}
		}
		@media (max-height: 760px) {
			i {
				line-height: 46px;
			}
		}
	}
	&::-webkit-scrollbar {
		display: none;
	}
`;

class Navigation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			navbar: false,
			_id: '',
			name: '',
		};
		this.handleResize = this.handleResize.bind(this);
	}

	componentDidUpdate() {
		const { __ } = this.context;
		setBadge(this.props.unreadConversationsCount, __('Inbox'));
	}
	componentWillReceiveProps(nextProps) {
		if (
			nextProps.unreadConversationsCount > this.props.unreadConversationsCount
		) {
		}
	}
	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}
	handleResize() {
		// Close the navbar if the screen width is more than 767px
		if (window.innerWidth > 767 && this.state.navbar) {
			this.setState({ navbar: false });
		}
	}
	getLocationCheck(path) {
		try {
			return window.location.pathname == path ? true : false;
		} catch (error) {
			return false;
		}
	}

	// componentDidUpdate() {
	// 	for (const url of globalUrlList) {
	//         if (this.getLocationCheck(url)) {
	//             isOrgSelected = false;
	//             break; // Exit loop once a match is found
	//         }
	//     }
	// }

	logout() {
		const { LOGIN_TOKEN_KEY, LOGIN_REFRESH_TOKEN_KEY } = consts;
		mAPI.sendPostAPI(
			`auth/logout`,
			{
				authorization: localStore.getItem("token"),
			},
			(data) => {
				localStorage.removeItem(LOGIN_TOKEN_KEY);
				localStorage.removeItem(LOGIN_REFRESH_TOKEN_KEY);

				localStorage.removeItem("REACT_APP_API_SUBSCRIPTION_URL");
				localStorage.removeItem("REACT_APP_API_URL");
				localStorage.removeItem("REACT_FS_SERVER_HOST");
				localStorage.removeItem("USER_ID");

				// localStore.removeItem('selected-tenant');
				localStore.removeItem("token");
				localStore.removeItem("user");

				if (data && data.redirectUrl) {
					window.location.href = data.redirectUrl;
				} else {
					window.location.href = "/";
				}

				// window.location.href = "/";
			},
			(errorCode, data) => {
				Alert.error(`errorCode : ${data}`);
			},
			`private`,
			{},
			"DELETE"
		);
	};


	render() {
		let isOrgSelected = localStore.getItem('selected-tenant');
		let { currentUser } = this.props;
		const { __ } = this.context;
		currentUser = currentUser || {};
		let agentRole = currentUser.role || '';
		// if (this.getLocationCheck('/organization')) {
		// 	isOrgSelected = false;
		// }
		if (globalUrlList.some(url => this.getLocationCheck(url))) {
			isOrgSelected = false;
		}
		return (
			<React.Fragment>
				<span
					onClick={() => {
						// this.state.navbar
						// 	? this.setState({ navbar: false })
						// 	: this.setState({ navbar: true });
						this.setState({ navbar: !this.state.navbar })
					}}
					style={{ zIndex: 999 }}
					className={`material-symbols-outlined menu-button ${this.state.navbar ? 'menu-open' : 'menu-close'
						} `}
				>
					menu_open
				</span>
				{this.state.navbar ? (
					<Mobilenavicon>
						<NavMob>
							{agentAccess.includes(currentUser.role) && (
								<React.Fragment>
									{(agentRole == 1 || agentRole == 3) && (
										<React.Fragment>
											<Tip text={__('Organization')}>
												<NavLink to='/organization' activeClassName='active'>
													<NavIcon>
														<span className='material-symbols-outlined'>
															corporate_fare
														</span>
													</NavIcon>
												</NavLink>
											</Tip>
										</React.Fragment>
									)}
									{!isOrgSelected && (
										<React.Fragment>
											<Tip text={__("Settings")}>
												<NavLink to="/organization-settings" activeClassName="active">
													<NavIcon>
														<span className="material-symbols-outlined">
															settings
														</span>
													</NavIcon>
												</NavLink>
											</Tip>
										</React.Fragment>
									)}
									{isOrgSelected && (
										<React.Fragment>
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.Dashboard,
											]) && (
													<Tip text={__('Dashboard')}>
														<NavLink
															to='/dashboard'
															activeClassName='active'
														>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	dashboard
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.Dashboard,
											]) && (
													<Tip text={__('Dynamic Dashboard')}>
														<NavLink
															to='/dynamic-dashboard'
															activeClassName='active'
														>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	area_chart
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.Dashboard,
											]) && (
													<Tip text={__('Chart Dashboard')}>
														<NavLink
															to='/chart-dashboard'
															activeClassName='active'
														>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	leaderboard
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.LiveMonitor,
											]) && (
													<Tip text={__('Live Monitor')}>
														<NavLink to='/live-monitor' activeClassName='active'>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	desktop_windows
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.Dialpad,
											]) && (
													<Tip text={__('Dialpad')}>
														<NavLink to='/dial-pad' activeClassName='active'>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	dialpad
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(
												this.props.accessDefination,
												permissionModulesKeys.ChatScreen
											) && <Tip text={__('Message')}>
													<NavLink to='/message' activeClassName='active'>
														<NavIcon>
															<span className='material-symbols-outlined'>
																chat
															</span>
														</NavIcon>
													</NavLink>
												</Tip>
											}
											{isAccessForAll(
												this.props.accessDefination,
												permissionModulesKeys.Reports
											) && (
													<Tip text={__('Reporting')}>
														<NavLink to='/reporting' activeClassName='active'>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	analytics
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.Team,
											]) && (
													<Tip text={__('Teams')}>
														<NavLink to='/team' activeClassName='active'>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	groups_2
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.Campaigns,
											]) && (
													<Tip text={__('Campaigns')}>
														<NavLink to='/campaigns' activeClassName='active'>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	campaign
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(
												this.props.accessDefination,
												permissionModulesKeys.Settings
											) && (
													<Tip text={__('Settings')}>
														<NavLink to='/settings' activeClassName='active'>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	settings
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
										</React.Fragment>
									)}
								</React.Fragment>
							)}
							{otherUser.includes(currentUser.role) &&
								isAccessForAll(this.props.accessDefination, [
									permissionKeys.Dialpad,
								]) && (
									<Tip text={__('Dialpad')}>
										<NavLink to='/dial-pad' activeClassName='active'>
											<NavIcon>
												<span className='material-symbols-outlined'>dialpad</span>
											</NavIcon>
										</NavLink>
									</Tip>
								)}
							{otherUser.includes(currentUser.role) &&
								isAccessForAll(this.props.accessDefination, [
									permissionKeys.ChatScreen,
								]) && (
									<Tip text={__('Message')}>
										<NavLink to='/chat-screen' activeClassName='active'>
											<NavIcon>
												<span className='material-symbols-outlined'>forum</span>
											</NavIcon>
										</NavLink>
									</Tip>
								)}
							{otherUser.includes(currentUser.role) && (!this.props.accessDefination || isAccessForAll(
								this.props.accessDefination,
								permissionModulesKeys.Reports
							)) && (
									<Tip text={__('Reporting')}>
										<NavLink to='/reporting' activeClassName='active'>
											<NavIcon>
												<span className='material-symbols-outlined'>
													analytics
												</span>
											</NavIcon>
										</NavLink>
									</Tip>
								)}
							{otherUser.includes(currentUser.role) &&
								isAccessForAll(this.props.accessDefination, [
									permissionKeys.Logout,
								]) && (
									<Tip text={__('Logout')}>
										<NavLink to='/sign-in' activeClassName='active' onClick={(e) => {
											e.preventDefault();
											this.logout();
										}}>
											<NavIcon>
												<span className='material-symbols-outlined'>logout</span>
											</NavIcon>
										</NavLink>
									</Tip>
								)}
						</NavMob>
					</Mobilenavicon>
				) : (
					<LeftNavigation>
						<NavLink to='/' className='menu-icon'>
							<img
								src={companyIcon}
								alt='stream'
								style={{ width: 35, height: 35 }}
							/>
						</NavLink>
						<Nav>
							{agentAccess.includes(currentUser.role) && (
								<React.Fragment>
									{(agentRole == 1 || agentRole == 3) && (
										<React.Fragment>
											<Tip text={__('Organization')}>
												<NavLink
													to='/organization'
													activeClassName='active'
													onClick={() => {
														this.setState({ selectedTenant: '' });
													}}
												>
													<NavIcon>
														<span className='material-symbols-outlined'>
															corporate_fare
														</span>
													</NavIcon>
												</NavLink>
											</Tip>
											{!isOrgSelected && (
												<React.Fragment>
													<Tip text={__("Settings")}>
														<NavLink to="/organization-settings" activeClassName="active">
															<NavIcon>
																<span className="material-symbols-outlined">
																	settings
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												</React.Fragment>
											)}
											{this.showSettingOption
												? isAccessForAll(
													this.props.accessDefination,
													permissionModulesKeys.Settings
												) && (
													<Tip text={__('Settings')}>
														<NavLink
															to='/admin/setting'
															activeClassName='active'
														>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	settings
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)
												: ''}
										</React.Fragment>
									)}
									{isOrgSelected && (
										<React.Fragment>
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.Dashboard,
											]) && (
													<Tip text={__('Dashboard')}>
														<NavLink
															to='/dashboard'
															activeClassName='active'
														>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	dashboard
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.Dashboard,
											]) && (
													<Tip text={__('Dynamic Dashboard')}>
														<NavLink
															to='/dynamic-dashboard'
															activeClassName='active'
														>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	area_chart
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.Dashboard,
											]) && (
													<Tip text={__('Chart Dashboard')}>
														<NavLink
															to='/chart-dashboard'
															activeClassName='active'
														>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	leaderboard
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.LiveMonitor,
											]) && (
													<Tip text={__('Live Monitor')}>
														<NavLink to='/live-monitor' activeClassName='active'>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	desktop_windows
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.Dialpad,
											]) && (
													<Tip text={__('Dialpad')}>
														<NavLink to='/dial-pad' activeClassName='active'>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	dialpad
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(
												this.props.accessDefination,
												permissionModulesKeys.ChatScreen
											) && agentRole !== 5 && (
													<Tip text={__('Message')}>
														<NavLink to='/message' activeClassName='active'>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	chat
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(
												this.props.accessDefination,
												permissionModulesKeys.Reports
											) && (
													<Tip text={__('Reporting')}>
														<NavLink to='/reporting' activeClassName='active'>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	analytics
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.Team,
											]) && (
													<Tip text={__('Teams')}>
														<NavLink to='/team' activeClassName='active'>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	groups_2
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{isAccessForAll(this.props.accessDefination, [
												permissionKeys.Campaigns,
											]) && (
													<Tip text={__('Campaigns')}>
														<NavLink to='/campaigns' activeClassName='active'>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	campaign
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
											{this.props.onCall ? (
												<Tip text={__('CTI Config')}>
													<NavLink to='/cti-config' activeClassName='active'>
														<NavIcon>
															<span className='material-symbols-outlined'>
																line_style
															</span>
														</NavIcon>
													</NavLink>
												</Tip>
											) : (
												''
											)}
											{isAccessForAll(
												this.props.accessDefination,
												permissionModulesKeys.Settings
											) && (
													<Tip text={__('Settings')}>
														<NavLink to='/settings' activeClassName='active'>
															<NavIcon>
																<span className='material-symbols-outlined'>
																	settings
																</span>
															</NavIcon>
														</NavLink>
													</Tip>
												)}
										</React.Fragment>
									)}
								</React.Fragment>
							)}
							{otherUser.includes(currentUser.role) && (
								<React.Fragment>
									{isAccessForAll(this.props.accessDefination, [
										permissionKeys.Dialpad,
									]) && (
											<Tip text={__('Dialpad')}>
												<NavLink to='/dial-pad' activeClassName='active'>
													<NavIcon>
														<span className='material-symbols-outlined'>dialpad</span>
													</NavIcon>
												</NavLink>
											</Tip>
										)}
									{<Tip text={__('Message')}>
										<NavLink to='/chat-screen' activeClassName='active'>
											<NavIcon>
												<span className='material-symbols-outlined'>forum</span>
											</NavIcon>
										</NavLink>
									</Tip>}
									{/* {isAccessForAll(
										this.props.accessDefination,
										permissionModulesKeys.Reports
									) && (
										<Tip text={__('Reporting')}>
											<NavLink to='/reporting'>
												<NavIcon>
													<span className='material-symbols-outlined'>
														analytics
													</span>
												</NavIcon>
											</NavLink>
										</Tip>
									)} */}
								</React.Fragment>
							)}
							{otherUser.includes(currentUser.role) && (!this.props.accessDefination || isAccessForAll(
								this.props.accessDefination,
								permissionModulesKeys.Reports
							)) && (
									<Tip text={__('Reporting')}>
										<NavLink to='/reporting' activeClassName='active'>
											<NavIcon>
												<span className='material-symbols-outlined'>
													analytics
												</span>
											</NavIcon>
										</NavLink>
									</Tip>
								)}
						</Nav>
					</LeftNavigation>
				)}
			</React.Fragment>
		);
	}
}
Navigation.propTypes = {
	unreadConversationsCount: PropTypes.number,
};
Navigation.contextTypes = {
	__: PropTypes.func,
	currentUser: PropTypes.object,
};
const stateToProps = (state) => ({
	currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' }),
	origanisation: globalStateSelector.getDynamic(state, {
		key: 'origanisation',
	}),
	accessDefination: globalStateSelector.getDynamic(state, {
		key: 'accessDefination',
	}),
});

export default connect(stateToProps)(Navigation);



// WEBPACK FOOTER //
// src/modules/theme/theme1/layout/components/Navigation.js